import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccVentureEntrepreneur } from '@interfaces';


export function getColumns(util: UtilityService) {
	const columns: GridColumn<AccVentureEntrepreneur, unknown>[] = [
		buildColumn(util, 'Id', row => row.accEntrepreneurId),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Percent', row => row.completionPercentage, { header: 'Course Completion %' }),
		buildColumn(util, 'YesNo', row => !!row.uniqueVideoId, { header: 'Has Intro Video' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Last Updated' }),
	];

	return columns;

}
